module.exports = __webpack_public_path__ + "static/media/listingImgAuthority.9a8c6daf.svg";